import type { StandardMateDrivenComponentConstraint } from '../solver';
import { AssemblyTransformToolMode } from './MoveComponentTypes';

/**
 * 装配体零部件变换意图对应的 driven 约束集合。
 */
export type AssemblyComponentDrivenConstraintMap = Readonly<Record<string, StandardMateDrivenComponentConstraint>>;

/**
 * 为 Move/Rotate Component 交互创建统一的求解器 driven 约束。
 *
 * 设计说明：
 * Move 与 Rotate 都不能把被用户操作的零件临时当成完整 fixed 组件。闭环机构需要在用户明确输入的分量之外释放
 * 另一类分量，才能沿剩余自由度联动求解。该函数是视口拖拽、能力探测和服务式预览共用的唯一语义入口。
 *
 * @param componentInstanceId 用户直接驱动的组件实例 ID。
 * @param toolMode 当前装配变换工具模式。
 * @returns 传递给标准配合求解器的 driven 分量约束。
 */
export function createAssemblyComponentDrivenConstraintsForToolMode(
  componentInstanceId: string,
  toolMode: AssemblyTransformToolMode,
): AssemblyComponentDrivenConstraintMap {
  if (toolMode === AssemblyTransformToolMode.Rotate) {
    return {
      [componentInstanceId]: {
        preserveRotation: true,
        preserveTranslation: false,
      },
    };
  }

  return {
    [componentInstanceId]: {
      preserveTranslation: true,
      preserveRotation: false,
    },
  };
}
